import React from 'react';
import { Form, Input } from 'antd';

const DescriptionFormItem = () => (
    <Form.Item
        name="description"
        label="Beschreibung"
        rules={[{ max: 255, message: 'Die Beschreibung darf nicht länger als 255 Zeichen sein!' }]}
    >
        <Input />
    </Form.Item>
);

export default DescriptionFormItem;
